export const COMPANY = 'RADOST IT j.d.o.o.'
export const COPYRIGHT = `© Padraig Lynch 2017-${new Date().getFullYear()} | All Rights Reserved`
export const ADDRESS = 'Ulica Grgura Budislavića 99, 23000, Zadar, Croatia'
export const EMAIL = 'info@radostit.com'
export const MAILTO = `mailto:${EMAIL}`
export const GA_CODE = 'UA-106332401-1'
